export interface PacketCraftLookup {
  craft: string;
  description: string;
  nonUnion: boolean;
}
